import './App.css';
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Layout from './layout/layout';
import ItemAdd from './components/items/add';
import ItemDetails from './components/items/details';
import ItemEdit from './components/items/edit';
import Login from './components/login/login';
import RequireAuth from './components/requireAuth/requireAuth';
import { USER_ROLES } from './services/User';
import CountryAdd from './components/countries/add';
import CountryList from './components/countries/list';
import CountryEdit from './components/countries/edit';
import LayoutCountries from './layout/layoutCountries';
import ManageTools from './components/tools/edit';
import MenuOrder from './components/menuOrder/menuOrder';
import PrintPreview from './components/items/print';
import LayoutPrint from './layout/layoutPrint';
import UserList from './components/users/list';
import UserAdd from './components/users/add';
import UserEdit from './components/users/edit';
import ResetPassword from './components/resetPassword/resetPassword';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/login' element={<Login />}></Route>
        <Route path='/reset-password' element={<ResetPassword/>}></Route>
        <Route element={<RequireAuth allowedRoles={[ USER_ROLES.ADMIN_COUNTRY, USER_ROLES.USER, USER_ROLES.ADMIN ]} />}>
          <Route path='/' element={<LayoutCountries />}>
            <Route path="/" element={<CountryList />} />
          </Route>
        </Route>

        <Route element={<RequireAuth allowedRoles={[ USER_ROLES.ADMIN_COUNTRY, USER_ROLES.ADMIN ]} />}>
          <Route path='/' element={<LayoutCountries />}>
            <Route path="/admin/users/edit/:id" element={<UserEdit />} />
            <Route path="/admin/users" element={<UserList />} />
            <Route path="/admin/add-user" element={<UserAdd />} />
          </Route>
        </Route>

        <Route element={<RequireAuth allowedRoles={[ USER_ROLES.ADMIN_COUNTRY, USER_ROLES.USER, USER_ROLES.ADMIN ]} />}>
          <Route path='/' element={<Layout />}>
            <Route path="/:country" element={<ItemDetails />} />
            <Route path="/:country/:id" element={<ItemDetails />} />
            <Route path="/:country/tools" element={<ManageTools />} />
          </Route>
          <Route path='/' element={<LayoutPrint />}>
            <Route path="/:country/print" element={<PrintPreview />} />
          </Route>
        </Route>
      
        <Route element={<RequireAuth allowedRoles={[ USER_ROLES.ADMIN_COUNTRY, USER_ROLES.ADMIN]} />}>
          <Route path='/' element={<Layout />}>
            <Route path="/" element={<ItemAdd />} />
            <Route path="/:country/edit/:id" element={<ItemEdit />} />
            <Route path="/:country/add" element={<ItemAdd />} />
            <Route path="/:country/tools" element={<ManageTools />} />
            <Route path="/:country/menuorder" element={<MenuOrder />} />
          </Route>
        </Route>
        <Route element={<RequireAuth allowedRoles={[USER_ROLES.ADMIN]} />}>
          <Route path='/admin' element={<LayoutCountries />}>
            {/* <Route path="/admin/country/edit/:id" element={<CountryEdit />}/> */}
            <Route path="/admin/add-country" element={<CountryAdd />} />
          </Route>
        </Route>
      </Routes>
    </Router>

  );
}

export default App;
